import { instance } from './index';

//지면 목록 조회
function inventoryList() {
  return instance.get('api/inventories');
}

//지면 상세조회
function detailInventory(id) {
  return instance.get(`api/inventories/${id}`);
}

//지면 생성
function createInventory(data) {
  return instance.post('api/inventories', data);
}

//지면 수정
function updateInventory(id, data) {
  return instance.put(`api/inventories/${id}`, data);
}

//지면 내 옵션 아이템 변경
function updateOptionItemInventory(id, data) {
  return instance.put(`api/inventories/${id}`, data);
}

//해당 지면에 이미 설정되어 있는 캠페인 목록
function campaignListInInventory(id) {
  return instance.get(`api/inventories/${id}/campaigns`);
}

//해당 지면의 옵션 목록 조회(옵션 아이템 포함)
function getOptionListByInventory(id) {
  return instance.get(`api/inventories/${id}/options`);
}

export {
  inventoryList,
  detailInventory,
  createInventory,
  updateInventory,
  updateOptionItemInventory,
  campaignListInInventory,
  getOptionListByInventory,
};
